import React, { useState, useEffect, useCallback } from "react";
import * as api from "../services/projectApi";
import { useAuth } from "../../auth/AuthContext";

export default function NotesPanel({ projectId }) {
  const { has } = useAuth();
  const [notes, setNotes] = useState([]);
  const [title, setTitle] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    api.listNotes(projectId).then(setNotes).catch((e) => setError(e.response?.data?.message || e.message));
  }, [projectId]);

  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    if (!note.trim()) return;
    setBusy(true);
    setError(null);
    try {
      await api.addNote(projectId, { title: title || undefined, note });
      setTitle("");
      setNote("");
      load();
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    await api.deleteNote(id);
    load();
  };

  return (
    <div className="proj-panel">
      <h4>Notes</h4>
      {error && <div className="proj-alert">{error}</div>}

      {has("note.manage") && (
        <form onSubmit={add} className="note-form">
          <input placeholder="Title (optional)" value={title} onChange={(e) => setTitle(e.target.value)} />
          <textarea rows={2} placeholder="Write a note…" value={note} onChange={(e) => setNote(e.target.value)} />
          <button className="proj-btn proj-btn-primary" disabled={busy || !note.trim()}>Add note</button>
        </form>
      )}

      <div className="note-list">
        {notes.length === 0 && <p className="proj-muted">No notes yet.</p>}
        {notes.map((n) => (
          <div key={n.id} className="note-item">
            <div>
              {n.title && <strong>{n.title}</strong>}
              <p>{n.note}</p>
              <span className="proj-sub">{new Date(n.createdAt).toLocaleString()}</span>
            </div>
            {has("note.manage") && (
              <button className="proj-link proj-link-danger" onClick={() => remove(n.id)}>delete</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
